import AbstractStonecodeFileFileModel from './AbstractStonecodeFileFileModel';
import doc                            from '@widesk-core/decorators/doc';
import { downloadUrl }                from '@/helpers/DownloadHelper';

@doc.urnResource('stonecode_file_file')
export default class StonecodeFileFileModel extends AbstractStonecodeFileFileModel {
	get url() {
		return this.get('@url', '');
	}

	public async download(name?: string) {
		await downloadUrl(this.url, name || this.name);
	}
}
